// 系统操作
export default {
    time: 'время',
    deviceName: 'Название оборудования',
    deviceSN: 'оборудованиеSN',
    operationContent: 'Содержание операции',
}